module.exports = __webpack_public_path__ + "static/media/radio.c830c4ad.png";